import { FechaFunctionsService } from '@/utils/functions.service';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DetalleArqueoComponent } from '@components/arqueo/detalle-arqueo/detalle-arqueo.component';
import { ListaArqueoComponent } from '@components/arqueo/lista-arqueo/lista-arqueo.component';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-arqueo',
  templateUrl: './arqueo.component.html',
  styleUrls: ['./arqueo.component.scss']
})
export class ArqueoComponent {
  rows: Array<any>;
  rowsDetalle: Array<any>;
  estados: Array<any>;
  filterForm: FormGroup;
  isLoading: boolean = false;
  bsRangeValue: Date[];
  efectivoTotal: number;
  @ViewChild(ListaArqueoComponent) listaArqueo!: ListaArqueoComponent;
  @ViewChild(DetalleArqueoComponent) DetalleArqueo!: DetalleArqueoComponent;

  constructor(
    public generalService: GeneralService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private loadingService: LoadingService,
    public Func: FechaFunctionsService) {
  }

  async ngOnInit() {
    //await this.getData();
  }


  onlyNumber(e: any) {
    const regExp = /[^0-9]+/g;
    e.target.value = e.target.value.replace(regExp, '');
  }

  registraMovimiento(form) {
    let rows = this.DetalleArqueo.rows;

    if (this.efectivoTotal - form.egreso_movimiento > 0 && form.id_tipomovimiento == 2) {
      this.generalService
        .postCrear("arqueo/movimiento", {
          "id_tipomovimiento": 4,
          "fecha_movimiento": this.Func.DateFormatedBD(form.fecha_movimiento),
          "hora_movimiento": this.Func.TimeNow(),
          "ingreso_movimiento": 0,
          "egreso_movimiento": this.efectivoTotal - form.egreso_movimiento,
          "motivo_movimiento": form.motivo_movimiento
        })
        .then(async res => {
          await this.sleep(1000);
          this.generalService
            .postCrear("arqueo/movimiento", {
              "id_tipomovimiento": form.id_tipomovimiento,
              "fecha_movimiento": this.Func.DateFormatedBD(form.fecha_movimiento),
              "hora_movimiento": this.Func.TimeNow(),
              "ingreso_movimiento": form.ingreso_movimiento,
              "egreso_movimiento": form.egreso_movimiento,
              "motivo_movimiento": form.motivo_movimiento
            })
        })
        .then(async res => {
          this.toastr.success('Registro exitoso!');
          await this.sleep(1000);
          this.DetalleArqueo.getDataDetalle();
          this.listaArqueo.getData();
        })
        .catch(err => this.toastr.error('Error al crear!'))
    }
    else {
      this.generalService
        .postCrear("arqueo/movimiento", {
          "id_tipomovimiento": form.id_tipomovimiento,
          "fecha_movimiento": this.Func.DateFormatedBD(form.fecha_movimiento),
          "hora_movimiento": this.Func.TimeNow(),
          "ingreso_movimiento": form.ingreso_movimiento,
          "egreso_movimiento": form.egreso_movimiento,
          "motivo_movimiento": form.motivo_movimiento
        })
        .then(async res => {
          this.toastr.success('Registro exitoso!');
          await this.sleep(1000);
          this.DetalleArqueo.getDataDetalle();
          this.listaArqueo.getData();
        })
        .catch(err => this.toastr.error('Error al crear!'))
    }
  }

  ObtieneTotalEfectivo(valor) {
    this.efectivoTotal = valor
  }

  sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

}
